import { render, staticRenderFns } from "./menuPersonal.vue?vue&type=template&id=53873e94&scoped=true&"
import script from "./menuPersonal.vue?vue&type=script&lang=js&"
export * from "./menuPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53873e94",
  null
  
)

export default component.exports